module.exports = __webpack_public_path__ + "img/inp_phone.fc8b1679.png";